// App-side delegate for `@heidi/templates/data` (S2/S1, ARCFE-1017).
// The analytics dispatch stayed: it is an app reaction, fired from a port at
// the position it always fired (ARCFE-921).
import {
  trackCommunityTemplateLiked,
  trackCommunityTemplateUnliked,
} from '@/lib/analytics/scribe/community';
import {
  COMMUNITY_TEMPLATE_BATCH_LIKE_STATUS_KEY,
  COMMUNITY_TEMPLATE_LIKE_STATUS_KEY,
  type LikeResponse,
} from '@heidi/templates/contracts';
import { useMutateCommunityTemplateLike as useMutateCommunityTemplateLikeCore } from '@heidi/templates/data';

export { COMMUNITY_TEMPLATE_BATCH_LIKE_STATUS_KEY, COMMUNITY_TEMPLATE_LIKE_STATUS_KEY };

export function useMutateCommunityTemplateLike({
  templateId,
  onSuccess,
}: {
  templateId: string;
  onSuccess?: (data: LikeResponse) => void;
}) {
  return useMutateCommunityTemplateLikeCore({
    templateId,
    onSuccess,
    onLikeChanged: (liked, id) => {
      if (liked) {
        trackCommunityTemplateLiked({ templateId: id });
      } else {
        trackCommunityTemplateUnliked({ templateId: id });
      }
    },
  });
}
